module.exports = __webpack_public_path__ + "static/media/default-profile-picture.97609973.svg";